// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wPdS","fullView":"styles_fullView__3RmK0"};